import { createSlice } from '@reduxjs/toolkit';
import authOperations from './auth-operations';

const initialState = {
  user: {
    name: null,
    email: null,
  },
  token: null,
  isLoggedIn: false,
  isBeingLoggedIn: false,
  errorRegister: '',
  errorLogin: '',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  extraReducers: {
    [authOperations.register.fulfilled](state, action) {
      state.user = action.payload.user;
      state.errorRegister = '';
    },
    [authOperations.register.pending](state) {
      state.user = { name: null, email: null };
      state.errorRegister = '';
    },
    [authOperations.register.rejected](state, action) {
      state.user = { name: null, email: null };
      state.errorRegister = action.error.message;
    },
    [authOperations.logIn.fulfilled](state, action) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isLoggedIn = true;
      state.errorLogin = '';
    },
    [authOperations.logIn.rejected](state, action) {
      state.user = { name: null, email: null };
      state.errorLogin = action.error.message;
    },
    [authOperations.logOut.fulfilled](state) {
      state.user = { name: null, email: null };
      state.token = null;
      state.isLoggedIn = false;
    },
    [authOperations.fetchCurrentUser.pending](state) {
      state.isBeingLoggedIn = true;
    },
    [authOperations.fetchCurrentUser.fulfilled](state, action) {
      state.user = action.payload;
      state.isLoggedIn = true;
      state.isBeingLoggedIn = false;
    },
    [authOperations.fetchCurrentUser.rejected](state) {
      state.isBeingLoggedIn = false;
    },
  },
});

export default authSlice.reducer;
